module.exports = __webpack_public_path__ + "img/not_found_img.2c060891.jpg";